module.exports = __webpack_public_path__ + "img/A.8ace15db.png";